import { Injectable, inject } from '@angular/core';
import { ApiEndpointService } from '@rci/self-serve-shared';
import { WIRELESS_ROUTE } from '../app.constant';

@Injectable()
export class PortInAppConfigService {
  private readonly apiConfig = inject(ApiEndpointService);

  get algoliaConfig() {
    return {
      baseUrl: this.apiConfig.algoliaBaseUrl,
      headers: this.apiConfig.algoliaHeaders,
      apiDebounceTime: 500,
    };
  }

  get fallbackRoute() {
    return `/${WIRELESS_ROUTE}`;
  }
}
